import React from 'react';
import Sheet16Table from './SheetTables/Sheet16Table';
import Sheet17Table from './SheetTables/Sheet17Table';
import Sheet3Table from './SheetTables/Sheet3Table';
import Sheet19Table from './SheetTables/Sheet19Table';
import SheetOther from './SheetTables/SheetOther';
import '../../../Styles/DIUO/TableComponent.scss';

const TableComponent = ({ index, sheet, sheetNumber, onInputChange }) => {
  const handleChange = (field) => (e) => {
    onInputChange(field, e.target.value);
  };

  const handleFileChange = (field) => (e) => {
    if (e.target.files && e.target.files[0]) {
      onInputChange(field, e.target.files[0]);
    } else {
      onInputChange(field, null);
    }
  };

  const handleDeleteImage = (field) => {
    onInputChange(field, null);
  };

  switch (sheetNumber) {
    case 3:
      return <Sheet3Table index={index} sheet={sheet} />

    case 16:
      return <Sheet16Table index={index} sheet={sheet} />

    case 17:
      return <Sheet17Table index={index} sheet={sheet} />

    case 19:
      return <Sheet19Table index={index} sheet={sheet} />

    default:
      return <SheetOther index={index} sheet={sheet} sheetNumber={sheetNumber} handleChange={handleChange} handleFileChange={handleFileChange} handleDeleteImage={handleDeleteImage} />
  }
};

export default TableComponent;
